import * as React from 'react'

import {
  Sheet,
  SheetCloseButton,
  SheetContent,
  SheetOverlay,
  SheetTitle,
} from '@wartek-id/sheet'
import { Button } from '@wartek-id/button'

import { Listbox } from 'components/Listbox'
import { Alert } from 'components/Alert'

import type { PacketFilterKeys } from 'types/assessment'

interface SheetSelectPhaseProps {
  isOpen: boolean
  onClose: React.Dispatch<React.SetStateAction<boolean>>
  subjects: string[]
  selectedSubject: string
  setValue: (value: string, key: PacketFilterKeys) => void
}
const SheetSelectPhase = ({
  isOpen,
  onClose,
  subjects,
  selectedSubject,
  setValue,
}: SheetSelectPhaseProps) => {
  const [selectedList, setSelectedList] = React.useState<string>('')

  React.useEffect(() => {
    setSelectedList(selectedSubject)
  }, [selectedSubject])

  return (
    <Sheet isOpen={isOpen} onClose={onClose} sheetSize="xl">
      <SheetOverlay />
      <SheetContent className="max-w-xl m-auto">
        <SheetTitle>Pilih Mata Pelajaran</SheetTitle>
        <div
          className="px-4 pb-4"
          style={{ height: 'calc(80vh - 72px - 64px)', overflowY: 'scroll' }}
        >
          {subjects.map((subject, idx) => (
            <Listbox
              key={idx}
              onClick={() => setSelectedList(subject)}
              selected={subject === selectedList}
            >
              {subject}
            </Listbox>
          ))}
          <Alert color="gray" icon="info" className="mt-2">
            Pilihan materi lainnya sedang dalam proses kurasi, nantikan
            kedepannya
          </Alert>
          <div className="bg-white fixed w-full left-0 bottom-0 py-3 px-4">
            <Button
              color="orange"
              onClick={() => {
                onClose(false)
                setValue(selectedList, 'subject')
              }}
              fullWidth
            >
              Terapkan
            </Button>
          </div>
        </div>
        <SheetCloseButton />
      </SheetContent>
    </Sheet>
  )
}

export default SheetSelectPhase
